//const url = 'http://localhost:3001';
//const url = 'http://198.245.50.155:3001';
//const url = 'https://mhiservers3.com';
const url = 'https://api.pecunovus.net';
export default url;
